<template>
    <app-admin-layout>
        <Head>
            <title>Dashboard</title>
        </Head>

        <div class="portal-search">
            <div class="container">
                <div class="row">
                    <div class="col col-6">
                        <card>
                            <card-header>
                                <card-overline>Suchergebnis</card-overline>
                                <card-title>Kunden</card-title>
                            </card-header>
                            <card-content>
                                <table class="table table--stripped table--card">
                                    <thead>
                                    <tr>
                                        <th>Kunden.-Nr</th>
                                        <th>Firma</th>
                                        <th>Name</th>
                                        <th>Telefon</th>
                                        <th>Email</th>
                                        <th>Adresse</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="client in clientUser" :key="client.index">
                                        <td>
                                            <a :href="this.$$route('client-user.edit', {'clientUser':client.id})">{{
                                                    client.client_no
                                                }}</a></td>
                                        <td>{{ client.company }}</td>
                                        <td>{{ client.name }}</td>
                                        <td>{{ client.phone }}</td>
                                        <td>{{ client.email }}</td>
                                        <td>{{ client.street }} {{ client.street_no }}, {{ client.zip }}
                                            {{ client.city }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </card-content>
                        </card>
                    </div>
                    <div class="col col-6">
                        <card>
                            <card-header>
                                <card-overline>Suchergebnis</card-overline>
                                <card-title>Produzenten</card-title>
                            </card-header>
                            <card-content>
                                <table class="table table--stripped table--card">
                                    <thead>
                                    <tr>
                                        <th>Prod.-Nr</th>
                                        <th>Firma</th>
                                        <th>Name</th>
                                        <th>Telefon</th>
                                        <th>Email</th>
                                        <th>Adresse</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="producer in producerUser" :key="producer.index">
                                        <td><a :href="this.$$route('producer-user.edit', {'producerUser':producer.id})">{{
                                                producer.prod_no
                                            }}</a></td>
                                        <td>{{ producer.company }}</td>
                                        <td>{{ producer.name }}</td>
                                        <td>{{ producer.phone }}</td>
                                        <td>{{ producer.email }}</td>
                                        <td>{{ producer.street }} {{ producer.street_no }}, {{ producer.zip }}
                                            {{ producer.city }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </card-content>
                        </card>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';

export default {
    name: 'Result',
    components: {CardTitle, CardContent, CardOverline, CardHeader, Card, AppAdminLayout},
    props: {
        producerUser: Object,
        clientUser: Object,
    },
};
</script>
